import {XHTTP} from '@/shared/xhttp';
import {PileService} from "@/xhttp";
import {DateHelper} from "@/shared/utils";

@XHTTP(PileService, '/piles')
export class Pile {

	private _id: number;
	private _name: string;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set name(value: string) {
		this._name = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			name : this._name,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name  = data.name;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}
